import {Component} from "@angular/core"

import{DataService} from "../shared/dataService"
import { AttLogChart } from "../shared/interfaces/attLog";


@Component({
    selector :"home-record",
    templateUrl : "home.record.component.html",
    styleUrls: []
})


export class HomeRecordComponent
{
    public attlogChart : AttLogChart[] = [];
    public startDatestring : string;
    public endDate : Date = new Date(Date.now());
    public endDatestring : string;
    public startDate : Date = new Date(Date.now());
    constructor(private data: DataService)
    {
        /*
        this.startDate.setDate( (this.startDate.getDate()- 30));
        this.startDatestring = this.startDate.getFullYear().toString() + "-"  
                                  + (this.startDate.getMonth().toString().length> 1 
                                  ? (this.startDate.getMonth()+1).toString() : '0' 
                                  + (this.startDate.getMonth()+1)) +'-' + this.startDate.getDate().toString();
        this.endDatestring  = this.endDate.getFullYear().toString() + "-"  
                            + (this.endDate.getMonth().toString().length> 1 
                            ? (this.endDate.getMonth()+1).toString() : '0' 
                            + (this.endDate.getMonth()+1).toString()) +'-' + this.endDate.getDate().toString();
        */
       //FIX DAAE
       this.startDate.setDate( (this.startDate.getDate()- 30));
       this.startDatestring = this.startDate.getFullYear().toString() + "-"  
       + ((this.startDate.getMonth()+1).toString().length> 1 ? (this.startDate.getMonth()+1).toString() : '0' + (this.startDate.getMonth()+1)) +'-' 
       + (this.startDate.getDate().toString().length> 1? this.startDate.getDate().toString(): '0' + this.startDate.getDate().toString());
       //+ this.startDate.getDate().toString();
        this.endDatestring  = this.endDate.getFullYear().toString() + "-"  
       + ((this.endDate.getMonth()+1).toString().length> 1 ? (this.endDate.getMonth()+1).toString() : '0' + (this.endDate.getMonth()+1).toString()) +'-' 
       + (this.endDate.getDate().toString().length> 1? this.endDate.getDate().toString(): '0' + this.endDate.getDate().toString());
       //+ this.endDate.getDate().toString();
        console.log(this.startDatestring + " - " + this.endDatestring);
        this.data.loadGetAttLogsChart(this.startDatestring,this.endDatestring)
        .subscribe(sucess => {
            if (sucess) 
            {   
                this.attlogChart  = this.data.attlogChart;
            }
        });
    }
}
